import { FormItem, FormItemProps } from "@standard-forms/cdk";

interface InputProps {
  placeholder: string;
}

export class Input extends FormItem {
  override tag = 'standard-forms-input';

  override props: InputProps = {
    placeholder: ''
  };

  constructor(props: FormItemProps & InputProps) {
    super(props);

    this.props = {
      placeholder: props.placeholder
    }
  }

  override setTexts(texts: {label: string; placeholder: string}) {
    super.setTexts(texts);
    this.formControlComponent.placeholder = texts.placeholder;
  }

}
